import { useEffect, useState } from 'react'
import { useAppDispatch } from './reduxHooks'
import {isApiResponse} from '../services/isApiError'
import {openModal, openSnackbar} from '../store/slice/appSlice'
import {handleKnownErrors} from '../services/handleKnownErrors'


export const useHandleError = (
	error: unknown,
	defaultErrorMessage?: string,
): string => {
	const [handledError, setHandledError] = useState<string>('')
	const dispatch = useAppDispatch()

	useEffect(() => {
		if(error === undefined){
			setHandledError('')
		} else if (isApiResponse(error) && error.status === 500) {
			dispatch(openModal('server'))
		} else if (isApiResponse(error)) {
			console.error(error)
			const result = handleKnownErrors(error) ?? false
			if (result) {
				if ('message' in result) {
					setHandledError(result.message)
				} else if ('snackbar' in result) {
					dispatch(openSnackbar(result.snackbar))
				}
			} else {
				if (handledError) {
					setHandledError('')
				}
				//Sentry.captureException(new Error(JSON.stringify(error)))
				dispatch(
					openModal(
						defaultErrorMessage ?? `Сталася помилка, спробуйте пізніше ${process.env.REACT_APP_ENV === 'development' ? JSON.stringify(error) : ''}` ,
					),
				)
			}
		} else  {
			//Sentry.captureException(new Error(JSON.stringify(error)))
			let message = `Сталася помилка, спробуйте пізніше ${process.env.REACT_APP_ENV === 'development' ? JSON.stringify(error) : ''}`
			if (
				typeof error === 'object' &&
				error &&
				'error' in (error as { error: string }) &&
				(error as { error: string }).error === 'TypeError: Network request failed'
			) {
				message = 'Відсутній зв\'язок з інтернетом'
			} else if (
				typeof error === 'object' &&
				error &&
				'error' in (error as { error: string }) &&
				(error as { error: string }).error === 'TypeError: Network request timed out'
			) {
				message = 'Відсутній зв\'язок з сервером'
			}
			dispatch(openModal(defaultErrorMessage ?? message))
		}
	}, [error])

	return handledError
}
